import { WORK_ORDER_TEMPLATE } from "../../../types/templates/work-order/work-order-template.enum";
import {
  DealerAdSchema,
  EdmSchema,
  MerchDigitalSchema,
  MerchPrintSchema,
  PaidMediaSchema,
  SimpleSchema,
  WebBannerSchema,
} from "./work-order-validations";
import {
  WorkOrderDealerAdvertisingTemplate,
  WorkOrderInStoreDigitalTemplate,
  WorkOrderInStorePrintTemplate,
  WorkOrderPaidMediaTemplate,
  WorkOrderSimpleTemplate,
  WorkOrderWebTemplate,
} from "../../../features/new-work-order-briefs/work-order-templates";
import { WorkOrderEdmTemplate } from "../../../features/new-work-order-briefs/work-order-templates/edm";
import { WorkOrderTemplateViewType } from "./work-order-template-view.type";
import { TemplateView } from "../../../types/templates/template-view.interface";

export function getWorkOrderTemplateValidationSchema(template: WORK_ORDER_TEMPLATE | string) {
  switch (template) {
    case WORK_ORDER_TEMPLATE.DEALER_ADVERTISING:
      return DealerAdSchema;

    case WORK_ORDER_TEMPLATE.WEB:
      return WebBannerSchema;

    case WORK_ORDER_TEMPLATE.PAID_MEDIA:
      return PaidMediaSchema;

    case WORK_ORDER_TEMPLATE.EDM:
      return EdmSchema;

    case WORK_ORDER_TEMPLATE.INSTORE_DIGITAL:
      return MerchDigitalSchema;

    case WORK_ORDER_TEMPLATE.INSTORE_PRINT:
      return MerchPrintSchema;

    case WORK_ORDER_TEMPLATE.SIMPLE:
    default:
      return SimpleSchema;
  }
}

export const getWorkOrderTemplateViews = (): TemplateView<WorkOrderTemplateViewType>[] => [
  {
    name: WORK_ORDER_TEMPLATE.SIMPLE,
    view: WorkOrderSimpleTemplate,
  },
  {
    name: WORK_ORDER_TEMPLATE.WEB,
    view: WorkOrderWebTemplate,
  },
  {
    name: WORK_ORDER_TEMPLATE.DEALER_ADVERTISING,
    view: WorkOrderDealerAdvertisingTemplate,
  },
  {
    name: WORK_ORDER_TEMPLATE.INSTORE_DIGITAL,
    view: WorkOrderInStoreDigitalTemplate,
  },
  {
    name: WORK_ORDER_TEMPLATE.INSTORE_PRINT,
    view: WorkOrderInStorePrintTemplate,
  },
  {
    name: WORK_ORDER_TEMPLATE.PAID_MEDIA,
    view: WorkOrderPaidMediaTemplate,
  },
  {
    name: WORK_ORDER_TEMPLATE.EDM,
    view: WorkOrderEdmTemplate,
  },
];

export function getWorkOrderTemplateView(
  template: WORK_ORDER_TEMPLATE | string
): WorkOrderTemplateViewType {
  const result = getWorkOrderTemplateViews().find((view) => view.name === template);

  if (!result) {
    throw new Error(`View for ${template} not found`);
  }

  return result.view;
}
